import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-gray-600 text-sm">
            © 2025 UFCC Enterprise Monitoring Tool. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
